"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FACILITIES_TYPES_LIST = void 0;
exports.FACILITIES_TYPES_LIST = [
    'Activated Sludge',
    'Chlorination',
    'Clarifier',
    'Cogeneration',
    'Corrosion Control',
    'Disinfection',
    'District Metered Area',
    'Filtration',
    'Odor Control',
    'Pre-treatment',
    'Primary Treatment',
    'Pump Station',
    'Screening',
    'Secondary Treatment',
    'Sewer Shed',
    'Solids Handling',
    'Tertiary Treatment',
    'Wastewater Collection',
    'Wastewater Treatment',
    'Water Distribution',
    'Water Treatment',
    'Wet Weather Station',
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRmFjaWxpdHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdHlwZXMvRmFjaWxpdHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSxxQkFBcUIsR0FBRztJQUNqQyxrQkFBa0I7SUFDbEIsY0FBYztJQUNkLFdBQVc7SUFDWCxjQUFjO0lBQ2QsbUJBQW1CO0lBQ25CLGNBQWM7SUFDZCx1QkFBdUI7SUFDdkIsWUFBWTtJQUNaLGNBQWM7SUFDZCxlQUFlO0lBQ2YsbUJBQW1CO0lBQ25CLGNBQWM7SUFDZCxXQUFXO0lBQ1gscUJBQXFCO0lBQ3JCLFlBQVk7SUFDWixpQkFBaUI7SUFDakIsb0JBQW9CO0lBQ3BCLHVCQUF1QjtJQUN2QixzQkFBc0I7SUFDdEIsb0JBQW9CO0lBQ3BCLGlCQUFpQjtJQUNqQixxQkFBcUI7Q0FDZixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IEZBQ0lMSVRJRVNfVFlQRVNfTElTVCA9IFtcbiAgICAnQWN0aXZhdGVkIFNsdWRnZScsXG4gICAgJ0NobG9yaW5hdGlvbicsXG4gICAgJ0NsYXJpZmllcicsXG4gICAgJ0NvZ2VuZXJhdGlvbicsXG4gICAgJ0NvcnJvc2lvbiBDb250cm9sJyxcbiAgICAnRGlzaW5mZWN0aW9uJyxcbiAgICAnRGlzdHJpY3QgTWV0ZXJlZCBBcmVhJyxcbiAgICAnRmlsdHJhdGlvbicsXG4gICAgJ09kb3IgQ29udHJvbCcsXG4gICAgJ1ByZS10cmVhdG1lbnQnLFxuICAgICdQcmltYXJ5IFRyZWF0bWVudCcsXG4gICAgJ1B1bXAgU3RhdGlvbicsXG4gICAgJ1NjcmVlbmluZycsXG4gICAgJ1NlY29uZGFyeSBUcmVhdG1lbnQnLFxuICAgICdTZXdlciBTaGVkJyxcbiAgICAnU29saWRzIEhhbmRsaW5nJyxcbiAgICAnVGVydGlhcnkgVHJlYXRtZW50JyxcbiAgICAnV2FzdGV3YXRlciBDb2xsZWN0aW9uJyxcbiAgICAnV2FzdGV3YXRlciBUcmVhdG1lbnQnLFxuICAgICdXYXRlciBEaXN0cmlidXRpb24nLFxuICAgICdXYXRlciBUcmVhdG1lbnQnLFxuICAgICdXZXQgV2VhdGhlciBTdGF0aW9uJyxcbl0gYXMgY29uc3Q7XG5cbmV4cG9ydCB0eXBlIExpZnRTdGF0aW9uVHlwZSA9IHR5cGVvZiBGQUNJTElUSUVTX1RZUEVTX0xJU1RbbnVtYmVyXTtcbiJdfQ==